import Actions from "./UserActivityActionTypes";

export const fetchAllUserActivity = (params = {}) => {
    return {
        type: Actions.FETCH_ALL_USER_ACTIVITY,
        payload: params,
    };
};
